import React from 'react';
import cavity from '../../../assets/images/cavity.png';
import fluride from '../../../assets/images/fluoride.png';
import whitening from '../../../assets/images/whitening.png';
import treatment from '../../../assets/images/treatment.png';
import { Link } from 'react-router-dom';

const Services = () => {
    return (
        <div>
            <div className='text-center my-8'>
                <p className='text-secondary font-bold'>OUR SERVICES</p>
                <p className='text-4xl'>Services we Provide</p>
            </div>

            <div className='lg:flex justify-evenly gap-5  mt-8 my-16'>
                <div className="card w-full bg-base-100 shadow-xl mt-8">
                    <figure className="px-10 pt-10">
                        <img src={fluride} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center">
                        <h2 className="card-title">Fluoride Treatment</h2>
                        <p>Fluoride treatment strengthens teeth, prevents cavities, and keeps your smile healthier for longer.</p>

                    </div>
                </div>

                <div className="card w-full bg-base-100 shadow-xl mt-8">
                    <figure className="px-10 pt-10">
                        <img src={cavity} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center">
                        <h2 className="card-title">Cavity Filling</h2>
                        <p>Cavity filling restores decayed teeth, prevents further damage, and protects your smile.</p>

                    </div>
                </div>

                <div className="card w-full bg-base-100 shadow-xl mt-8">
                    <figure className="px-10 pt-10">
                        <img src={whitening} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center">
                        <h2 className="card-title">Teeth Whitening</h2>
                        <p>Teeth whitening brightens your smile by removing stains and discoloration for a confident, radiant look.</p>

                    </div>
                </div>

            </div>

            <div className=''>

                <div className="hero ">
                    <div className="hero-content flex-col lg:flex-row ">
                        <img src={treatment} className="w-96 rounded-lg shadow-2xl lg:ml-36" alt='' />
                        <div className='lg:ml-20'>
                            <h1 className="text-2xl lg:text-5xl font-bold">Exceptional Dental</h1>
                            <h1 className="text-2xl lg:text-5xl font-bold"> Care, On Your Terms</h1>
                            <p className="py-6">At Doctor Portal, we focus on your comfort and care. We provide exceptional dental treatments for every smile. Our team listens to your needs and respects your time. You choose flexible options that fit your lifestyle. With us, quality care always comes on your terms.</p>
                            <Link to={"/login"} className="btn btn-secondary text-white">Get Started</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;